"use client"

import React from "react";
import PropTypes from "prop-types";
import { motion, useInView } from "framer-motion";
import Image from "next/image";

const SecuritySection = ({ screenWidth, blok }) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const heading = blok?.SecuritySection?.find(item => item.component === "Heading") || {};

  const cards = blok?.SecuritySection?.filter(item => item.component == "GenericCards") || []

  return (
    <div className="w-full">
      {/* Adding the keyframes animation directly within the component */}
      <style>{`
      @keyframes gradientFlow {
        0% {
          background-position: 200% 50%;
        }
        100% {
          background-position: -200% 50%;
        }
      }
    `}</style>

      {/* Section with animated gradient background */}
      <div
        style={{
          clipPath:
            screenWidth >= 1500
              ? "polygon(0% 0, 100% 7%, 100% 93%, 0% 100%)"
              : screenWidth >= 768
                ? "polygon(0% 0, 100% 5%, 100% 95%, 0% 100%)"
                : "none", // Trapezoidal shape
          background: `linear-gradient(
          90deg,
          #672C7B 0%,    /* Start with dark purple */
          #6D2F80 15%,   /* Intermediate soft purple */
          #493989 35%,   /* Shift to deep blue-purple */
          #4E3C92 50%,   /* Smooth blue transition */
          #493989 65%,   /* Keep consistency in blue-purple */
          #6D2F80 85%,   /* Return to soft purple */
          #672C7B 100%   /* End with dark purple */
        )`,
          backgroundSize: "400% 100%", // Makes the gradient wider than the container
          animation: "gradientFlow 20s linear infinite", // Apply smooth left-to-right flow
          minHeight: screenWidth >= 1024 ? "1022px" : "1300px", // Minimum height for the trapezoid
          // padding: "5rem 1rem", // Increased padding for better spacing
          color: "white",
        }}
        className="mt-4 lg:mt-10 flex flex-col justify-center"
      >
        {/* Section Heading */}
        <div className="flex text-center justify-center">
          <h4 className="font-aileron text-[28px] lg:text-[48px] 3xl:text-[56px] font-bold mb-6 mt-6 lg:mb-24 lg:mt-0 xl:mx-[340px] w-[1200px] px-4 text-white">
            {heading?.header}
          </h4>
        </div>

        {/* Cards Container */}
        <div
          ref={ref}
          className="grid grid-cols-1 lg:grid-cols-3 gap-6 xl:gap-[76px] max-w-[1200px] mx-auto px-4 xl:px-0 mb-8"
        >
          {/* Card 1 */}
          {cards.map((item,index) => {
            return <motion.div
            key={index}
              className="bg-white text-center text-gray-800 p-6 rounded-lg shadow-md border-[3px] border-[#9f98bf] overflow-hidden flex flex-col justify-between"
              initial={{ opacity: 0, x: -100 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div>
                <div className="mb-4">
                  <img
                    src={item.image.filename}
                    alt="Message Icon"
                    className="w-[80px] h-[68px] mx-auto"
                  />
                </div>
                <h3 className="font-aileron text-lg lg:text-xl font-bold mb-4 text-[#49378F] px-2 ">
                  {item.title}
                </h3>
                <p className="mb-6 px-2">
                  {item.description}
                </p>
              </div>
              <a href={"/" + item.url.cached_url} className="">
                <button className="bg-[#EF7B22] text-white py-2 px-6 hover:bg-[#D76F1F] rounded-md w-[169px] h-[45px]">
                  {item.ctaText}
                </button>
              </a>
            </motion.div>
          })}
        </div>
      </div>
    </div>
  );
};
SecuritySection.propTypes = {
  screenWidth: PropTypes.number.isRequired
};

export default SecuritySection;

